var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.items)?_c('Map'):_vm._e(),_c('transition',{attrs:{"name":_vm.getTransition}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }